import { COMMON_PERMISSIONS, composePermissions } from '@/commons/permissoesGrupos';

export default [
    // Lista de Pagamentos
    {
        path: '/financeiro',
        name: 'listaPagamentos',
        component: () => import('@/modules/financeiro/views/dashboard/FinanceiroView.vue'),
        meta: {
            requiresAuth: true,
            temFilhas: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'GESTAO')],
        },
        redirect: { name: 'pagamentosAutorizados' },
        children: [
            {
                path: '/financeiro/autorizados',
                name: 'pagamentosAutorizados',
                component: () => import('@/modules/financeiro/components/listas/ListaAutorizados.vue'),
            },
            {
                path: '/financeiro/pausados',
                name: 'pagamentosPausados',
                component: () => import('@/modules/financeiro/components/listas/ListaPausados.vue'),
            },
            {
                path: '/financeiro/emprocessamento',
                name: 'pagamentosEmProcessamento',
                component: () => import('@/modules/financeiro/components/listas/ListaEmProcessamento.vue'),
            },
            {
                path: '/financeiro/comerros',
                name: 'pagamentosComErros',
                component: () => import('@/modules/financeiro/components/listas/ListaComErros.vue'),
            }
        ]
    },

    // Lista de Pagamentos Concluídos
    {
        path: '/financeiro/concluidos',
        name: 'listaPagamentosConcluidos',
        component: () => import('@/modules/financeiro/views/listas/ListaPagamentosConcluidosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'GESTAO', 'PROJETO')],
        }
    },
    {
        path: '/financeiro/cancelados',
        name: 'listaPagamentosCancelados',
        component: () => import('@/modules/financeiro/views/listas/ListaPagamentosCanceladosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'GESTAO')],
        }
    },
    {
        path: '/financeiro/encargos',
        name: 'listaPagamentosEncargo',
        component: () => import('@/modules/financeiro/views/listas/ListaPagamentosEncargosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'GESTAO', 'ORDENADOR')],
        }
    },

    {
        path: '/financeiro/encargos/cadastrar',
        name: 'cadastrarEncargo',
        component: () => import('@/modules/financeiro/views/cadastros/CadastrarEncargoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'GESTAO')],
        }
    },

    {
        path: '/financeiro/encargos/:id',
        name: 'detalheSolicitacaoPagamentoEncargo',
        component: () => import('@/modules/financeiro/views/detalhes/DetalheSolicitacaoPagamentoEncargoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'GESTAO')],
        },
        props: true
    },

    // Lista de Subrubricas Financeiras
    {
        path: '/financeiro/subrubricas',
        name: 'listaSubrubricas',
        component: () => import('@/modules/financeiro/views/listas/ListaSubrubricasFinanceirasView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: composePermissions('CONTABILIDADE'),
        },
    },

    // Lista de Desembolsos Financeiros por Projeto
    {
        path: '/financeiro/desembolsos',
        name: 'listaDesembolsosFinanceiro',
        component: () => import('@/modules/financeiro/views/listas/ListaDesembolsosProjetoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.OPERACOES_FINANCEIRAS,
        },
    },

    // Lista de Encargos
    {
        path: '/financeiro/listaencargos',
        name: 'listaEncargos',
        component: () => import('@/modules/financeiro/views/listas/ListaEncargosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: COMMON_PERMISSIONS.OPERACOES_FINANCEIRAS,
        },
    },
    // Lista de Solicitações Financeiras
    {
        path: '/financeiro/listasolicitacoesfinanceiras',
        name: 'listaSolicitacoesFinanceiras',
        component: () => import('@/modules/financeiro/views/listas/ListaSolicitacoesFinanceirasView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'PROJETO', 'CONTABILIDADE')],
        },
    },
    // Cadastro de Solicitação Financeira
    {
        path: '/financeiro/:id/cadastrosolicitacaofinanceira',
        name: 'cadastroSolicitacaoFinanceira',
        component: () => import('@/modules/financeiro/views/solicitacoes/CadastroSolicitacaoFinanceiraView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'PROJETO')],
        },
    },
    // Detalhe da Solicitação Financeira
    {
        path: '/financeiro/solicitacoesfinanceiras/:id',
        name: 'detalheSolicitacaoFinanceira',
        component: () => import('@/modules/financeiro/views/detalhes/DetalheSolicitacaoFinanceiraView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'PROJETO', 'CONTABILIDADE')],
        },
    },

    // Exportações — Contas a Pagar
    {
        path: '/financeiro/exportacoes/contas-a-pagar',
        name: 'exportacaoContasAPagar',
        component: () => import('@/modules/financeiro/views/exportacoes/ExportacaoContasAPagarView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('CONTABILIDADE', 'FINANCEIRO')],
        },
    },

    // Exportações — Contas a Receber
    {
        path: '/financeiro/exportacoes/contas-a-receber',
        name: 'exportacaoContasAReceber',
        component: () => import('@/modules/financeiro/views/exportacoes/ExportacaoContasAReceberView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('CONTABILIDADE', 'FINANCEIRO')],
        },
    },

    // Cadastro de Conta Bancária
    {
        path: '/financeiro/contasbancarias/cadastrar',
        name: 'cadastroContaBancaria',
        component: () => import('@/modules/financeiro/views/cadastros/CadastroContaBancariaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE')],
        },
    },

    // Lista de Contas Bancárias
    {
        path: '/financeiro/contasbancarias',
        name: 'listaContasBancarias',
        component: () => import('@/modules/financeiro/views/listas/ContaBancariasView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE')],
            isRotaOrigem: true
        },
    },

    // Editar Conta Bancária
    {
        path: '/financeiro/contasbancarias/:id/editar',
        name: 'editarContaBancaria',
        component: () => import('@/modules/financeiro/views/cadastros/CadastroContaBancariaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE')],
        },
        props: true,
    },

    // Detalhe de Conta Bancária
    {
        path: '/financeiro/contasbancarias/:id',
        name: 'detalheContaBancaria',
        component: () => import('@/modules/financeiro/views/detalhes/DetalheContaBancariaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE')],
        },
        props: true,
    },

    // Detalhe do pagamento com o financeiro
    {
        path: '/financeiro/:id',
        name: 'detalhePagamento',
        component: () => import('@/modules/financeiro/views/detalhes/DetalhePagamentoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...COMMON_PERMISSIONS.OPERACOES_FINANCEIRAS],
        },
        props: true
    },

    // Calculadora de Encargos
    {
        path: '/financeiro/calculadoraencargos',
        name: 'calculadoraEncargos',
        component: () => import('@/modules/financeiro/views/detalhes/CalculadoraEncargosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.ADMINISTRADORES, ...composePermissions('FINANCEIRO', 'CONTABILIDADE', 'GESTAO', 'ORDENADOR', 'PROJETO')],
        }
    }
]